import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext, UserDataType } from "../../Modules/Auth/AuthContext";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import { Table } from "@mui/material";
import { TableBody } from "@mui/material";
import { TableRow } from "@mui/material";
import { TableCell } from "@mui/material";
import { Button } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { Paper } from "@mui/material";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import { Avatar } from "@mui/material";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { grades, departments, prefectures } from "../../Environment/Config";

function createData(
  name: string,
  value: string | number | boolean | null | undefined
) {
  return { name, value };
}

export function Account() {
  const { user, userData } = useAuthContext();
  const navigate = useNavigate();

  const handleMagazine = (data: boolean | undefined) => {
    if (data === true) {
      return "有";
    } else {
      return "無";
    }
  };

  const basicInfos = [
    createData("写真", user?.photoURL),
    createData("名前", user?.displayName),
    createData("メール", user?.email),
  ];

  const customInfos = [
    createData("ニックネーム", userData?.nickname),
    createData("所属", userData?.belongs),
    createData("ご職業", userData?.position),
    createData("メールマガジン配信の有無", handleMagazine(userData?.magazine)),
  ];

  const consoleDisplayName = (userData: UserDataType | null) => {
    if (userData?.nickname) {
      return userData.nickname;
    } else if (userData?.displayName) {
      return userData.displayName;
    } else {
      return "名無し";
    }
  };

  const handleOpenLink = (url: string) => {
    const toUrl = url;
    window.open(toUrl, "_blank");
  };

  const handleNavigation = (url: string) => {
    const toUrl = url;
    navigate(toUrl);
  };

  //userData.grade + passedGrade

  return (
    <div style={{ textAlign: "center" }}>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 1 }}>
        <Grid>
          <div style={{ textAlign: "center", paddingBottom: 16 }}>
            <Tooltip title={user?.displayName || ""}>
              <IconButton
                onClick={() => handleOpenLink("https://myaccount.google.com/")}
                sx={{ p: 0 }}
              >
                <Avatar
                  sx={{ width: 100, height: 100 }}
                  alt="Remy Sharp"
                  src={user?.photoURL || ""}
                />
              </IconButton>
            </Tooltip>
          </div>
          <Typography variant="h4" textAlign="center">
            ようこそ、{consoleDisplayName(userData)} さん
          </Typography>
        </Grid>

        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Typography variant="h6" ml={4} textAlign="center">
            アカウント情報
          </Typography>
          <Grid
            container
            sx={{
              mt: 3,
              ml: 2,
              mr: 1,
              minWidth: "90%",
              display: "grid",
              gridTemplateColumns: { md: "1fr 1fr" },
              justifyContents: "center",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Paper
              sx={{
                ml: 2,
                p: 2,
                minWidth: "80%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <React.Fragment>
                <Typography variant="h6" textAlign="left">
                  基本情報
                </Typography>
                <Grid sx={{ minHeight: "35vh" }}>
                  <Table sx={{ mt: 3 }} size="small">
                    <TableBody>
                      {basicInfos.map((row, index) => {
                        if (index === 0) {
                          return (
                            <TableRow key={index}>
                              <TableCell color="black">{row.name}</TableCell>
                              <TableCell>
                                <Avatar
                                  sx={{ fontsize: 300 }}
                                  alt="Remy Sharp"
                                  src={
                                    typeof row.value === "string"
                                      ? row.value
                                      : ""
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        } else {
                          return (
                            <TableRow key={index}>
                              <TableCell color="black">{row.name}</TableCell>
                              <TableCell>{row.value}</TableCell>
                            </TableRow>
                          );
                        }
                      })}
                    </TableBody>
                  </Table>
                </Grid>
                <Button
                  color="primary"
                  onClick={() =>
                    handleOpenLink("https://myaccount.google.com/")
                  }
                  sx={{ mt: 3 }}
                >
                  基本情報を編集
                </Button>
              </React.Fragment>
            </Paper>
            <Paper
              sx={{
                p: 2,
                ml: 2,
                minWidth: "80%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <React.Fragment>
                <Typography variant="h6" textAlign="left">
                  カスタム情報
                </Typography>
                <Grid sx={{ minHeight: "35vh" }}>
                  <Table sx={{ mt: 3 }} size="small">
                    <TableBody>
                      {customInfos.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell color="black">{row.name}</TableCell>
                          <TableCell>{row.value}</TableCell>
                        </TableRow>
                      ))}
                      {userData && userData.prefecture !== 0 ? (
                        <TableRow>
                          <TableCell color="black">都道府県</TableCell>
                          <TableCell>
                            {prefectures[userData.prefecture - 1]}
                          </TableCell>
                        </TableRow>
                      ) : (
                        <div></div>
                      )}
                      {userData && userData.grade !== 0 ? (
                        <TableRow>
                          <TableCell color="black">学年</TableCell>
                          <TableCell>
                            {grades[Math.min(5, userData.grade - 1)]}
                          </TableCell>
                        </TableRow>
                      ) : (
                        <div></div>
                      )}
                      {userData && userData.department !== 0 ? (
                        <TableRow>
                          <TableCell color="black">診療科</TableCell>
                          <TableCell>
                            {departments[userData.department - 1]}
                          </TableCell>
                        </TableRow>
                      ) : (
                        <div></div>
                      )}
                    </TableBody>
                  </Table>
                </Grid>
                <Button
                  color="primary"
                  onClick={() => handleNavigation("/mypage/changeforms")}
                  sx={{ mt: 3 }}
                >
                  カスタム情報を編集
                </Button>
              </React.Fragment>
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 3, mb: 3 }}>
          <Typography variant="h6" ml={4}>
            サポート
          </Typography>
          <Grid
            container
            sx={{
              mt: 3,
              ml: 2,
              mr: 1,
              minWidth: "90%",
              display: "grid",
              gridTemplateColumns: { md: "1fr 1fr" },
              justifyContents: "center",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Grid>
              <Card
                sx={{
                  p: 2,
                  ml: 2,
                  minHeight: "35vh",
                  minWidth: "80%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h6" textAlign="left">
                  ご利用ガイド
                </Typography>
                <Typography
                  variant="body1"
                  textAlign="left"
                  sx={{ ml: 2, mt: 2 }}
                >
                  Msta公式サイトにて、サポートページをご用意しております。
                  ご使用方法等の説明をしております。
                </Typography>
                <CardContent>
                  <LibraryBooksIcon
                    color="secondary"
                    sx={{ fontSize: 80 }}
                  ></LibraryBooksIcon>
                </CardContent>
                <Button
                  color="primary"
                  onClick={() =>
                    handleOpenLink(
                      "https://sites.google.com/mnes.org/msta-support/%E3%83%9B%E3%83%BC%E3%83%A0"
                    )
                  }
                  sx={{ mt: 3 }}
                >
                  ガイドを参照
                </Button>
              </Card>
            </Grid>
            <Grid>
              <Card
                sx={{
                  p: 2,
                  ml: 2,
                  minHeight: "35vh",
                  minWidth: "80%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h6" textAlign="left">
                  お問合せ
                </Typography>
                <Typography
                  variant="body1"
                  textAlign="left"
                  sx={{ ml: 2, mt: 2 }}
                >
                  何かご不明な点がございましたら、直接フォームにて承ります。
                  返信までお時間を頂く場合があります。
                </Typography>
                <CardContent>
                  <ContactSupportIcon
                    color="primary"
                    sx={{ fontSize: 80 }}
                  ></ContactSupportIcon>
                </CardContent>
                <Button
                  color="primary"
                  onClick={() =>
                    handleOpenLink("https://forms.gle/snGbX6kYNeg7qJ8s8")
                  }
                  sx={{ mt: 3 }}
                >
                  お問合せフォームへ移動
                </Button>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
